function TCSValue() {
    return 0.1;
  }
  
export default TCSValue;
  